import no_trial_tall1 from 'assets/sounds/no/workingmemory_numbers/wmTrial-numbers-1.mp3';
import no_norming_trial_tall1 from 'assets/sounds/no/workingmemory_numbers/Arbeidsminne-trial-ex.mp3';

import no_trial_tall2 from 'assets/sounds/no/workingmemory_numbers/wmTrial-numbers-2.mp3';
import no_trial_word1 from 'assets/sounds/no/workingmemory_words/wmTrial-words-1.mp3';
import no_trial_word2 from 'assets/sounds/no/workingmemory_words/wmTrial-words-2.mp3';

import no_correct1 from 'assets/sounds/no/workingmemory_numbers/correct-1.m4a';
import no_correct2 from 'assets/sounds/no/workingmemory_numbers/correct-1.m4a';

import no_incorrect1 from 'assets/sounds/no/workingmemory_numbers/incorrect-1.m4a';
import no_incorrect2 from 'assets/sounds/no/workingmemory_numbers/incorrect-2.m4a';

import no_ord_incorrect1 from 'assets/sounds/no/workingmemory_words/incorrect-3.m4a';
import no_ord_incorrect2 from 'assets/sounds/no/workingmemory_words/incorrect-4.m4a';



import no_tall1 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-1.mp3';
import no_tall2 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-2.mp3';
import no_tall3 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-3.mp3';
import no_tall4 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-4.mp3';
import no_tall5 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-5.mp3';
import no_tall6 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-6.mp3';
import no_tall7 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-7.mp3';
import no_tall8 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-8.mp3';
import no_tall9 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-9.mp3';
import no_tall10 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-10.mp3';
import no_tall11 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-11.mp3';
import no_tall12 from 'assets/sounds/no/workingmemory_numbers/workingmemory-numbers-12.mp3';
import no_more_numbers from 'assets/sounds/no/workingmemory_numbers/Arbeidminne-Na-kommer-det-flere-tal.mp3';

import no_word1 from 'assets/sounds/no/workingmemory_words/workingmemory-words-1.mp3';
import no_word2 from 'assets/sounds/no/workingmemory_words/workingmemory-words-2.mp3';
import no_word3 from 'assets/sounds/no/workingmemory_words/workingmemory-words-3.mp3';
import no_word4 from 'assets/sounds/no/workingmemory_words/workingmemory-words-4.mp3';
import no_word5 from 'assets/sounds/no/workingmemory_words/workingmemory-words-5.mp3';
import no_word6 from 'assets/sounds/no/workingmemory_words/workingmemory-words-6.mp3';
import no_word7 from 'assets/sounds/no/workingmemory_words/workingmemory-words-7.mp3';
import no_word8 from 'assets/sounds/no/workingmemory_words/workingmemory-words-8.mp3';
import no_word9 from 'assets/sounds/no/workingmemory_words/workingmemory-words-9.mp3';
import no_word10 from 'assets/sounds/no/workingmemory_words/workingmemory-words-10.mp3';
import no_word11 from 'assets/sounds/no/workingmemory_words/workingmemory-words-11.mp3';
import no_word12 from 'assets/sounds/no/workingmemory_words/workingmemory-words-12.mp3';
import no_more_words from 'assets/sounds/no/workingmemory_words/Arbeidsminne-Na-kommer-det-flere-ord.mp3';

import nn_trial_word1 from 'assets/sounds/nn/workingmemory_words/wmTrial-words-1.mp3';
import nn_trial_word2 from 'assets/sounds/nn/workingmemory_words/wmTrial-words-2.mp3';

import nn_trial_tall1 from 'assets/sounds/nn/workingmemory_numbers/wmTrial-numbers-1.mp3';
import nn_trial_tall2 from 'assets/sounds/nn/workingmemory_numbers/wmTrial-numbers-2.mp3';

import nn_tall_correct1 from 'assets/sounds/nn/workingmemory_numbers/correct-1.m4a';
import nn_tall_correct2 from 'assets/sounds/no/workingmemory_numbers/correct-1.m4a';

import nn_tall_incorrect1 from 'assets/sounds/nn/workingmemory_numbers/incorrect-1.m4a';
import nn_tall_incorrect2 from 'assets/sounds/nn/workingmemory_numbers/incorrect-2.m4a';

import nn_ord_incorrect1 from 'assets/sounds/nn/workingmemory_words/incorrect-1.m4a';
import nn_ord_incorrect2 from 'assets/sounds/nn/workingmemory_words/incorrect-2.m4a';

import nn_tall1 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-1.mp3';
import nn_tall2 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-2.mp3';
import nn_tall3 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-3.mp3';
import nn_tall4 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-4.mp3';
import nn_tall5 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-5.mp3';
import nn_tall6 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-6.mp3';
import nn_tall7 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-7.mp3';
import nn_tall8 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-8.mp3';
import nn_tall9 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-9.mp3';
import nn_tall10 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-10.mp3';
import nn_tall11 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-11.mp3';
import nn_tall12 from 'assets/sounds/nn/workingmemory_numbers/workingmemory-numbers-12.mp3';
import nn_more_numbers from 'assets/sounds/nn/workingmemory_numbers/nn-Arbeidsminne-No-kjem-det-flei-tal.mp3';

import nn_word1 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-1.mp3';
import nn_word2 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-2.mp3';
import nn_word3 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-3.mp3';
import nn_word4 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-4.mp3';
import nn_word5 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-5.mp3';
import nn_word6 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-6.mp3';
import nn_word7 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-7.mp3';
import nn_word8 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-8.mp3';
import nn_word9 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-9.mp3';
import nn_word10 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-10.mp3';
import nn_word11 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-11.mp3';
import nn_word12 from 'assets/sounds/nn/workingmemory_words/workingmemory-words-12.mp3';
import nn_more_words from 'assets/sounds/nn/workingmemory_words/nn-Arbeidsminne-No-kjem-det-flei-ord.mp3';

export const no_numbers_trial = [no_norming_trial_tall1];

export const no_numbers_answers = {
	correct1: no_correct1,

	incorrect1: no_incorrect1,
};

export const nn_numbers_trial = [nn_trial_tall1];
export const nn_numbers_answers = {
	correct1: nn_tall_correct1,
	incorrect1: nn_tall_incorrect1,
};

export const no_words_trial = [];

export const no_words_answers = {};

export const nn_words_trial = [];

export const nn_words_answers = {};

export const no_numbers = [
	no_tall1,
	no_tall2,
	no_tall3,
	no_tall4,
	no_tall5,
	no_tall6,
	no_tall7,
	no_tall8,
	no_tall9,
	no_tall10,
	no_tall11,
	no_tall12,
];
export const nn_numbers = [
	nn_tall1,
	nn_tall2,
	nn_tall3,
	nn_tall4,
	nn_tall5,
	nn_tall6,
	nn_tall7,
	nn_tall8,
	nn_tall9,
	nn_tall10,
	nn_tall11,
	nn_tall12,
];

export const no_numbers_more_items = no_more_numbers;
export const nn_numbers_more_items = nn_more_numbers;

export const no_words = [
	no_word1,
	no_word2,
	no_word3,
	no_word4,
	no_word5,
	no_word6,
	no_word7,
	no_word8,
	no_word9,
	no_word10,
	no_word11,
	no_word12,
];
export const nn_words = [
	nn_word1,
	nn_word2,
	nn_word3,
	nn_word4,
	nn_word5,
	nn_word6,
	nn_word7,
	nn_word8,
	nn_word9,
	nn_word10,
	nn_word11,
	nn_word12,
];

export const no_words_more_items = no_more_words;
export const nn_words_more_items = nn_more_words;

export const no_older_version_numbers_trial = [no_trial_tall1, no_trial_tall2];

export const no_older_version_numbers_answers = {
	correct1: no_correct1,
	correct2: no_correct2,

	incorrect1: no_incorrect1,
	incorrect2: no_incorrect2,
};

export const nn_older_version_numbers_trial = [nn_trial_tall1, nn_trial_tall2];
export const nn_older_version_numbers_answers = {
	correct1: nn_tall_correct1,
	correct2: nn_tall_correct2,
	incorrect1: nn_tall_incorrect1,
	incorrect2: nn_tall_incorrect2,
};

export const no_older_version_words_trial = [no_trial_word1, no_trial_word2];

export const no_older_version_words_answers = {
	correct1: no_correct1,
	correct2: no_correct1,
	incorrect1: no_ord_incorrect1,
	incorrect2: no_ord_incorrect2,
};

export const nn_older_version_words_trial = [nn_trial_word1, nn_trial_word2];

export const nn_older_version_words_answers = {
	correct1: nn_tall_correct1,
	correct2: nn_tall_correct1,
	incorrect1: nn_ord_incorrect1,
	incorrect2: nn_ord_incorrect2,
};
